module.exports = __webpack_public_path__ + "img/minus.93b685b4.svg";